// MUI components
import { useState, useContext } from 'react'
import { IntakeContext } from '../context/IntakeContext'

import { selectData } from 'layouts/onboarding'
import { renderMuiFormField } from 'utils/forms/renderMuiFormField'

import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'

// Soft UI Dashboard PRO React components
import SoftBox from 'components/SoftBox'
import SoftButton from './SoftButton'

import OnboardingYesNo from './OnboardingYesNo'
// import OnboardingYesNo from './OnboardingYesNo'

const Referral = () => {
  const { intakeState, updateIntakeStateAtKey, updateUser } =
    useContext(IntakeContext)

  const [referred, setReferred] = useState(false)

  const [nameQuestion, setNameQuestion] = useState(false)

  return (
    <Box sx={{ textAlign: 'left' }}>
      <SoftBox component="form" py={3}>
        <Box mb={1}>
          <Typography mb={1} variant="body2">
            Let us know who referred you and both of you will earn a giftcard!
          </Typography>
          <Typography mb={1} variant="h4" fontSize={{ xs: '20px', sm: '24px' }}>
            Nice to meet you {intakeState.firstName || ''}
          </Typography>
        </Box>
        <Grid item xs={6} mb={2}>
          {/* {renderMuiFormField({
            id: 'referralEmail',
            required: true,
            label: 'Did someone refer you to PARCO?',
            placeholder: 'No',
            inputType: 'select',
            // value: intakeState.firstName,
            onChange: (referred) => setReferred(referred),
            options: selectData.yesNo,
          })} */}
        </Grid>

        <OnboardingYesNo
          onChange={setReferred}
          subHeader={'Did someone refer you to PARCO?'}
        />

        {referred && (
          <Grid container>
            <Grid container columnSpacing={3}>
              {!nameQuestion ? (
                <>
                  <Grid item xs={12} mb={1}>
                    {renderMuiFormField({
                      id: 'referredByEmail',
                      required: true,
                      label: 'Email of referrer',
                      placeholder: 'johnsmith@gmail.com',
                      inputType: 'email',
                      value: intakeState.referredByEmail,
                      onChange: (referredByEmail) =>
                        updateIntakeStateAtKey({ referredByEmail }),
                    })}
                  </Grid>
                  <Grid item xs={12}>
                    <SoftBox display="flex" justifyContent="flex-start">
                      <SoftButton
                        variant="text"
                        color="info"
                        sx={{ height: '100%' }}
                        onClick={() => setNameQuestion(true)}
                      >
                        Use their name instead
                      </SoftButton>
                    </SoftBox>
                  </Grid>
                </>
              ) : (
                <>
                  <Grid item xs={12} mb={1}>
                    {renderMuiFormField({
                      id: 'referredByName',
                      required: true,
                      label: 'Full Name of Referrer',
                      placeholder: 'John Smith',
                      inputType: 'text',
                      value: intakeState.referredByName,
                      onChange: (referredByName) =>
                        updateIntakeStateAtKey({ referredByName }),
                    })}
                  </Grid>
                  <Grid item xs={12}>
                    <SoftBox display="flex" justifyContent="flex-start">
                      <SoftButton
                        variant="text"
                        color="info"
                        sx={{ height: '100%' }}
                        onClick={() => setNameQuestion(false)}
                      >
                        Use their email instead
                      </SoftButton>
                    </SoftBox>
                  </Grid>
                </>
              )}

              <Grid item xs={12} mb={2}>
                {renderMuiFormField({
                  id: 'giftCard',
                  required: true,
                  label: 'Select giftcard type',
                  placeholder: '$25 Amazon',
                  inputType: 'select',
                  value: intakeState.giftCard,
                  onChange: (giftCard) => updateIntakeStateAtKey({ giftCard }),
                  options: selectData.giftCards,
                })}
              </Grid>
            </Grid>
          </Grid>
        )}
      </SoftBox>
    </Box>
  )
}

export default Referral
